import { MantineProvider, createTheme } from "@mantine/core"
import { createRoot } from "react-dom/client"
import { App } from "atlas_forecasting_app/app"

const theme = createTheme({
  defaultRadius: "lg",
  primaryColor: "blue",
  fontFamily: '"Avenir Next", "Segoe UI", "Helvetica Neue", sans-serif',
  headings: {
    fontFamily: '"Iowan Old Style", "Palatino Linotype", "Book Antiqua", Georgia, serif',
    fontWeight: "700",
  },
})

export function mountAtlasForecastingApp() {
  const mount = document.getElementById("atlas-app")
  if (!mount) return

  createRoot(mount).render(
    <MantineProvider theme={theme} defaultColorScheme="light">
      <App />
    </MantineProvider>,
  )
}
